module.exports = function(media) {
	'use strict'
	media.directive('relatedGalleriesDir',relatedGalleriesDir);
	relatedGalleriesDir.$inject=[];
	function relatedGalleriesDir() {
		return {
			template: require('./partial/relatedGalleries.html'),
			controller:'relatedGalleriesController',
			controllerAs:'vmrg',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/relatedGalleries/js/directive/relatedGalleriesDirective.js
// module id = 523
// module chunks = 0